import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import parties from '../../config/parties';

const Member = () => {
  const navigate = useNavigate();
  const [member, setMember] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formattedCommittees =
    member &&
    member.committees &&
    member.committees.split('|').map((committee) => {
      const parts = committee.split('::');
      return `${parts[0]} - ${parts[1]}`;
    });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const memberId = window.location.href.split('/').pop();
        if (memberId) {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/members/id/${memberId}`);
          if (response.data.length > 0) {
            setMember(response.data[0]);
          }
        } else {
          navigate('/members/list');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // const prettyDate = (zuluDate) => {
  //   const date = new Date(zuluDate);

  //   const formattedDate = `${date.toLocaleDateString('en-ZA', {
  //     day: 'numeric',
  //     month: 'short',
  //     year: 'numeric',
  //   })} ${date.toLocaleTimeString('en-ZA', {
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     hour12: true,
  //   })}`;

  //   return formattedDate;
  // };

  function getPartyAbbreviation(partyId) {
    // Handle null, undefined, or empty partyId values
    if (!partyId) {
      return 'Unknown';
    }
    
    const party = parties.find((party) => party.value === partyId.toString());
    return party ? party.abbreviation : 'Unknown';
  }

  // function getPosition(id) {
  //   const position = positions.find((p) => p.value === id.toString());
  //   return position ? position.name : '';
  // }

  return (
    <>
      <PageHeader title="Member details" description="" className="mb-3"></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : member?.id ? (
        <Table hover responsive>
          <tbody>
            <tr>
              <td>
                Name: {member.title} {member.name} {member.surname}
              </td>
            </tr>
            <tr>
              <td>Status: {member.status}</td>
            </tr>
            <tr>
              <td>DOB: {member.dob}</td>
            </tr>
            <tr>
              <td>Gender: {member.gender == 'F' ? 'Female' : 'Male'}</td>
            </tr>
            <tr>
              <td>
                {member.profile_pic_url && member.profile_pic_url.includes('https') ? (
                  <img className="rounded" height={300} src={member.profile_pic_url} alt={member.name} />
                ) : member.profile_pic_url ? (
                  <img
                    className="rounded"
                    height={300}
                    src={`${process.env.REACT_APP_DOCS_BASE_URL}/img/mpls/webp/${
                      member.profile_pic_url.split('.')[0]
                    }.webp`}
                    alt={member.name}
                  />
                ) : (
                  <>
                    No image
                    <br />
                  </>
                )}
              </td>
            </tr>

            <tr>
              <td>Constituencies: {member.constituencies ? member.constituencies.split('|').join(', ') : 'None'}</td>
            </tr>
            <tr>
              <td>Party: {getPartyAbbreviation(member.party_id)}</td>
            </tr>
            <tr>
              <td>
                Position:{' '}
                {member.member_position
                  ? member.member_position
                  : member.position
                    ? member.position
                    : 'Member of the Provincial Legislature'}
              </td>
            </tr>
            <tr>
              <td>
                Committees:{' '}
                {formattedCommittees && formattedCommittees.length > 0
                  ? formattedCommittees.map((committee) => (
                      <>
                        <br />- {committee}
                      </>
                    ))
                  : 'None'}
              </td>
            </tr>
            {member.email1 && (
              <div>
                <strong>Email:</strong> <Link href={`mailto:${member.email1}`}>{member.email1}</Link>
                {member.email2?.length > 0 ? `, <Link href='mailto:${member.email1}'>${member.email2}</Link>` : ''}
              </div>
            )}
            {member.tel && (
              <div>
                <strong>Telephone:</strong> <Link href={`tel:${member.tel}`}>{member.tel}</Link>
              </div>
            )}
            {member.cell1 ||
              (member.cell2 && (
                <div>
                  <strong>Cellphone:</strong> <Link href={`tel:${member.cell1}`}>{member.cell1}</Link>
                  {member.cell2?.length > 0 ? `, <Link href='tel:${member.cell2}'>${member.cell2}</Link>` : ''}
                </div>
              ))}
            {member.website && (
              <div>
                <strong>Website:</strong> <Link href={`${member.website}`}>{member.website}</Link>
              </div>
            )}
            {member.facebook && (
              <div>
                <strong>Facebook:</strong> <Link href={`${member.facebook}`}>{member.facebook}</Link>
              </div>
            )}
            {member.twitter && (
              <div>
                <strong>Twitter:</strong> <Link href={`${member.twitter}`}>{member.twitter}</Link>
              </div>
            )}
          </tbody>
        </Table>
      ) : (
        <div>Member not found</div>
      )}
    </>
  );
};

export default Member;
